export class FileMetaData {
  fileName: string;
  fileSize: number = 0;
  fileType: string = "";
  lastModifiedTime: number = 0;
  lastModifiedDate: Date = null;
}

export class FileToUpload extends FileMetaData {
  fileUpload: File;
}
